import { render } from "./ReportsForm.vue?vue&type=template&id=a618f1b6&ts=true"
import script from "./ReportsForm.vue?vue&type=script&lang=ts"
export * from "./ReportsForm.vue?vue&type=script&lang=ts"

import "./ReportsForm.vue?vue&type=style&index=0&id=a618f1b6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__